module.exports = __webpack_public_path__ + "img/g_a_ru.40ee2cea.gif";